import { render, staticRenderFns } from "./productTemplate.vue?vue&type=template&id=c716539c&scoped=true&"
import script from "./productTemplate.vue?vue&type=script&lang=js&"
export * from "./productTemplate.vue?vue&type=script&lang=js&"
import style0 from "./productTemplate.vue?vue&type=style&index=0&id=c716539c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c716539c",
  null
  
)

export default component.exports